/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { useToast } from '../../../../components/Toats';
import { StepperComponent } from '../../../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { LoadingSpan } from '../../../../components/Loadings/loadingSpan';
import { deletePlantOne } from '../../../../../services/plantsService';

type Props = {
    id: string | null | undefined;
    data: any;
    show: boolean;
    handleClose: () => void
}


const modalsRoot = document.getElementById('root-modals') || document.body

const ModalDeletePlant = ({show, handleClose, id, data}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const deletePlantSubmit = async () => {
    try {
      setLoading(true)

      await deletePlantOne(id ? id : "");
      toggleToast("Sucesso ao excluir a usina. ", "success")

    } catch (error) {
      toggleToast("Erro ao excluir a usina. ", "error")
    }finally{
      setLoading(false)
      closed()
      // handleClose()
    //   setTimeout(()=>{
    //     window.location.reload()
    //   }, 2000);
    }
  }

  const submit = () => {
    deletePlantSubmit()
  }


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Excluir Usina {" - "}{data && data.name ? data.name : "Não identificado"}</span>
          {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
        </h3>

        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
         

          {/*begin::Content */}
          <div className='flex-row-fluid py-lg-0'>
            <div style={{marginBottom: '1.5rem'}}>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='text-muted mt-1 fw-semibold fs-5'>Deseja excluir essa usina permanentemente?</span>
                </h3>
            </div>

            <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed p-5' style={{marginBottom: '2rem'}}>
                <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon-2tx svg-icon-danger me-4'
                />
                <div className='d-flex flex-column'>
                    <span className='fw-bold text-danger fs-6 mb-2'>Esta ação não pode ser desfeita</span>
                    <span className='text-gray-700 fs-7 mb-2'>
                        Ao excluir a usina, todo o histórico construído ao longo do tempo deixará de existir para ela, incluindo:
                    </span>
                    <ul className='text-gray-700 fs-7 ps-5 mb-2'>
                        <li>Histórico de geração de energia e gráficos de desempenho;</li>
                        <li>Vínculo com faturas, unidades consumidoras e listas de rateio;</li>
                        <li>Relatórios gerados e o acompanhamento do progresso da usina;</li>
                        <li>Alertas, ordens de serviço, propostas, comentários e arquivos associados.</li>
                    </ul>
                    <span className='text-gray-700 fs-7'>
                        Caso a usina seja importada novamente, ela começará do zero, sem nenhuma dessas informações.
                    </span>
                </div>
            </div>
            {/*begin::Form */}
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <button
                    type='button'
                    className='btn btn-lg btn-light'
                    disabled={loading}
                    onClick={() => {
                        closed()
                    }}
                    //data-kt-stepper-action='submit'
                >
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr063.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                    <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
                    
                </button>

                <button
                    type='button'
                    className={`btn btn-lg btn-danger`}
                    disabled={loading}
                    //data-kt-stepper-action='submit'
                    onClick={submit}
                >
                    Excluir
                    {
                        loading ? 
                        <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                        :
                        <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                        />
                    }
                </button>
            </div>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalDeletePlant}
